import { render } from "./ButtonBar.vue?vue&type=template&id=2521fece&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&lang=js"
export * from "./ButtonBar.vue?vue&type=script&lang=js"

import "./ButtonBar.vue?vue&type=style&index=0&id=2521fece&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2521fece"

export default script